<template>
  <v-dialog v-model="dialog" :persistent="options.persistent" :max-width="options.width" :style="{ zIndex: options.zIndex }" @keydown.esc="cancel">
    <v-card>
      <v-toolbar dark :color="options.color" dense flat>
        <v-toolbar-title class="white--text">{{ title }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text v-show="!!message" class="pa-4">
        <p v-if="subtitle != null"><strong>{{subtitle}}</strong></p>
        <p>{{ message }}</p>
        <p v-if="message2 != null">{{ message2 }}</p>
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click.native="agree">Si</v-btn>
        <v-btn color="grey" text @click.native="cancel">No</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

/**
 * Vuetify Confirm Dialog component
 *
 * Insert component where you want to use it:
 * <confirm ref="confirm"></confirm>
 *
 * Call it:
 * this.$refs.confirm.open('Delete', 'Are you sure?', 'lorem ipsum dolor sit amet',{ color: 'red' }).then((confirm) => {})
 * Or use await:
 * if (await this.$refs.confirm.open('Delete', 'Are you sure?', 'lorem ipsum dolor sit amet', { color: 'red' })) {
 *   // yes
 * }
 * else {
 *   // cancel
 * }
 *
 * Alternatively you can place it in main App component and access it globally via this.$root.$confirm
 * <template>
 *   <v-app>
 *     ...
 *     <confirm ref="confirm"></confirm>
 *   </v-app>
 * </template>
 *
 * mounted() {
 *   this.$root.$confirm = this.$refs.confirm.open
 * }
 */
export default {
  name: 'Comfirm',
  data: () => {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      message: null,
      message2: null,
      title: null,
      subtitle: null,
      options: {
        persistent: true,
        color: 'primary',
        width: 290,
        zIndex: 200
      }
    }
  },
  methods: {
    open(title, subtitle, message, message2, options) {
      this.dialog = true
      this.title = title
      this.subtitle = subtitle
      this.message = message
      this.message2 = message2
      this.options = Object.assign(this.options, options)
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    agree() {
      this.resolve(true)
      this.dialog = false
    },
    cancel() {
      this.resolve(false)
      this.dialog = false
    }
  }
}
</script>